/* *
 * GLOBAL config vars for hoverReact app
 * */

class Config {
  static envs = {
    PRODUCTION: 'production',
    DEVELOPMENT: 'development',
    TEST: 'test',
  };

  get env() {
    return process.env.NODE_ENV || Config.envs.DEVELOPMENT;
  }

  isProduction() {
    return this.env === Config.envs.PRODUCTION;
  }

  isDevelopment() {
    return this.env === Config.envs.DEVELOPMENT;
  }

  isTesting() {
    throw new Error("isTesting is not implemented yet, don't use");
    // return this.env === Config.envs.TEST
  }

  isReduxLogginEnabled() {
    return !!window.enableReduxLogging;
  }
}

export const configUtils = new Config();

export const facebookAppId = {
  PRODUCTION: '812249348866876',
};
